import { storage } from "@/lib/storage";
import { usePropertyInteractionStore } from "@/stores/property-interaction";
import { logger } from "@/utils/logger";
import { useEffect } from "react";

export function useViewedPropertiesInitialization() {
	const initViewedProperties = usePropertyInteractionStore(state => state.initViewedProperties);

	useEffect(() => {
		// Only run once on component mount
		if (typeof window !== "undefined") {
			// Use async storage (IndexedDB) since that's where viewed properties are saved
			storage
				.getItem<string[]>("viewed_properties")
				.then(viewedIds => {
					if (viewedIds && Array.isArray(viewedIds)) {
						initViewedProperties(viewedIds);
					}
				})
				.catch(error => {
					logger.error("Failed to load viewed properties from storage:", error);
				});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []); // Empty dependency array - only run once on mount
}

export function useIsPropertyViewed() {
	const viewedProperties = usePropertyInteractionStore(state => state.viewedProperties);

	return (propertyId: string) => {
		return viewedProperties instanceof Set ? viewedProperties.has(propertyId) : false;
	};
}
